import { Type } from 'class-transformer';
import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';
import { PaymentDto } from '../payment.dto';
import { GiftCardDto } from './giftCard.dto';
import { GiftCardReasonDto } from './giftCardReason.dto';

export class GiftCardTopupDto extends BaseDto {
  @IsNumber()
  topupAmount: number;

  @IsNumber()
  previousBalance: number;

  @IsBoolean()
  processed?: boolean;

  @Type(() => GiftCardDto)
  giftCard: GiftCardDto;

  @Type(() => GiftCardReasonDto)
  giftCardReason: GiftCardReasonDto;

  @IsString()
  note?: string;

  @Type(() => PaymentDto)
  @IsOptional()
  payment?: PaymentDto;

  @Type(() => MerchantDto)
  merchant?: MerchantDto;

  @IsBoolean()
  @IsOptional()
  isInstorePayment?: boolean;

  @IsBoolean()
  @IsOptional()
  isRefunded?: boolean;
}
